import styles from './stickyHeader.scss';
import { Component } from 'react';
import { Router } from '../../../configs/routes';
class StickyHeader extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      sticky: true,
    };
  }

  public componentDidUpdate(prevProps: any) {
    const activeItemArr = Object.keys(this.props.plansActiveState).filter(
      ele => this.props.plansActiveState[ele]
    );
    const prevActiveItemArr = Object.keys(prevProps.plansActiveState).filter(
      ele => prevProps.plansActiveState[ele]
    );
    if (activeItemArr.length === 0 && this.state.sticky) {
      return this.setState({ sticky: false });
    } else if (activeItemArr.length && !this.state.sticky) {
      return this.setState({ sticky: true });
    }
    if (
      activeItemArr.length === prevActiveItemArr.length &&
      activeItemArr[0] !== prevActiveItemArr[0] &&
      this.props.isMobile
    ) {
      this.inputRefs.get(activeItemArr[0]).scrollIntoView({ inline: 'center' });
    }
  }

  public inputRefs: any = new Map();
  public setRef = (id: any) => ref => {
    this.inputRefs.set(id, ref);
  };

  public render() {
    const { SECTION_STICKY_HEADER, insideView, plansActiveState } = this.props;
    const assignhrefHash = divIdentifier => {
      let newDivIdentifier = '';
      switch (true) {
        case divIdentifier === 'fundsCategory':
          newDivIdentifier = 'top-funds';
          break;
        case divIdentifier === 'learnMutualFunds':
          newDivIdentifier = 'learn-to-invest';
          break;
        case divIdentifier === 'nfo':
          newDivIdentifier = 'new-fund-offer';
          break;
        case divIdentifier === 'fundHouses':
          newDivIdentifier = 'fund-houses';
          break;
        case divIdentifier === 'topPlans':
          newDivIdentifier = 'top-plans';
          break;
        default:
          newDivIdentifier = divIdentifier;
      }
      return newDivIdentifier;
    };
    return (
      <div
        className={`lil-flex lil-h-20 lil-items-center lil-justify-around ${
          this.state.sticky ? styles['stickyBar'] : styles['relativeBar']
        } lil-px-5 sm:lil-mt-6 sm:lil-justify-start`}
      >
        {SECTION_STICKY_HEADER.map(ele => {
          return (
            <div
              ref={this.setRef(ele.divIdentifier)}
              key={ele.divIdentifier}
              style={{ minWidth: '150px' }}
              className={`lil-w-1/5 lil-flex lil-h-full lil-items-center lil-justify-center ${
                plansActiveState[ele.divIdentifier]
                  ? 'lil-border-b-lg lil-text-blue-300 lil-border-blue-300'
                  : ''
              }`}
            >
              <span
                data-href={'#' + assignhrefHash(ele.divIdentifier)}
                className="lil-font-bold lil-text-s-20 lil-cursor-pointer"
                onClick={e => {
                  e.preventDefault();
                  Router.push(
                    `/mutual-funds#${
                      e.currentTarget.getAttribute('data-href').split('#')[1]
                    }`
                  );

                  insideView(ele.divIdentifier, true, true);
                }}
              >
                {ele.title}
              </span>
            </div>
          );
        })}
      </div>
    );
  }
}

export default StickyHeader;



// WEBPACK FOOTER //
// ./components/homePageNew/stickyHeader/stickyHeader.tsx